import { Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import FormikTextbox from "src/components/Common/UI/Formik/FormikTextbox";


const NodeSearchForm = ({ initialValues, onSubmit, onClearForm }: NodeSearchFormProps) => {
  const { t } = useTranslation();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        onSubmit(values, formikHelpers);
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <Container fluid className="p-0">
            <Row>
              <Col xs={6}>
                <FormikTextbox 
                  label={"Περιγραφή"} 
                  fieldName={"description"}           
                />
              </Col>
            </Row>
            <Row className="row justify-content-end">
              <Col xs="2" className="m-2 me-0">
                <Button
                  type="button"
                  size="sm"
                  color="warning"
                  disabled={isSubmitting}
                  onClick={onClearForm}
                >
                  {t("Καθαρισμός")}
                </Button>
              </Col>

              <Col xs="2" className="m-2">
                <Button
                  type="submit"
                  size="sm"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {t("Αναζήτηση")}
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      )}
    </Formik>
  )
}

export default NodeSearchForm;

type NodeSearchFormProps = {
  initialValues: INodeSearchForm;
  onSubmit: (
    values: INodeSearchForm,
    formikHelpers: FormikHelpers<INodeSearchForm>
  ) => void;
  onClearForm: () => void;
}